﻿"use strict";
export function scrollTop() {
    $("#go_up").click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".body").offset().top
        }, 300);
    });
}